import classes from "@/Modals/BaseModal.module.css";
import Input from "../Input/Input";
import PropTypes from "prop-types";

export default function BasicInput({
  formik,
  fieldName,
  saveError,
  label,
  inputDivClass,
  inputClass,
  errorTextClass,
  disabled,
  required,
  ...props
}) {
  return (
    <Input
      required={required}
      labelClass={classes.label}
      label={label}
      disabled={disabled}
      className={inputDivClass || classes.inputDiv}
      placeholder={`Enter ${label}`}
      inputContainerClass={inputClass || classes.input}
      value={formik.values[fieldName]}
      setValue={(val) => formik.setFieldValue(fieldName, val)}
      errorTextClass={errorTextClass || classes.errorText}
      errorText={
        (formik.touched[fieldName] && formik.errors[fieldName]) ||
        (saveError?.status === 422 &&
          saveError.response?.data?.errors?.[fieldName]?.join(" "))
      }
      {...props}
    />
  );
}

BasicInput.propTypes = {
  formik: PropTypes.object,
  fieldName: PropTypes.string,
  saveError: PropTypes.object,
  label: PropTypes.string,
};
